import { Link, browserHistory } from 'react-router';
import React, { Component } from 'react';

import i18n, { getPathLanguage } from '../i18n';

export function patchTo(to) {
  if (typeof to === 'string') {
    if (!getPathLanguage(to)) {
      to = `/${i18n.language}${to}`;
    }

  } else if (typeof to === 'object') {
    if (!getPathLanguage(to.pathname)) {
      to = Object.assign({}, to, {
        pathname: `/${i18n.language}${to.pathname}`
      });
    }
  }

  return to;
}

export default class I18nLink extends Component {
  render() {
    const { to, ...props } = this.props;

    return (
      <Link to={patchTo(to)} {...props} />
    );
  }
}

export function redirect(to) {
  browserHistory.push(patchTo(to));
}



// WEBPACK FOOTER //
// ./src/widgets/I18nLink.js